import moment, { utc } from 'moment';

export class DateService {
  public static toEndOfDayString(date: Date): string {
    return moment(date).format('YYYY-MM-DD') + 'T23:59:59.999Z';
  }

  public static toStartOfDayString(date: Date): string {
    return moment(date).format('YYYY-MM-DD') + 'T00:00:00.000Z';
  }

  public static getWeekday(timestamp: Date) {
    return utc(timestamp).format('ddd');
  }

  public static getDate(timestamp: Date) {
    return utc(timestamp).format('MM/DD/YYYY');
  }

  public static getTime(timestamp: Date) {
    return utc(timestamp).format('h:mm A');
  }

  /**
   * @param yearMonthDay ISO 8601 format: YYYY-MM-DD
   * @returns Date
   */
  public static dateFromISODateString(isoDate?: string): Date {
    if (!isoDate) {
      return undefined;
    }
    const dateParts = isoDate.split('-').map(Number);
    return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
  }
}
